export interface WhatsAppSendPayload {
  idLeadCorretor365: string;
  mensagem?: string;
  arquivo?: File | Blob;
  nomeArquivo?: string;
}

export interface WhatsAppBulkPayload {
  idsLeadCorretor365: string[];
  mensagem: string;
  idEmpreendimento365?: string;
  arquivos?: File[];
  links?: string[];
  dataEnvio?: string;
}

function getFileName(file: File | Blob): string {
  if (file instanceof File) return file.name;
  return "arquivo";
}

export function buildWhatsAppSendFormData(
  payload: WhatsAppSendPayload
): FormData {
  const formData = new FormData();

  formData.append("IdLeadCorretor365", payload.idLeadCorretor365);

  if (payload.arquivo) {
    formData.append("Mensagem", payload.mensagem || "");
    formData.append("Arquivo", payload.arquivo);
    formData.append(
      "NomeArquivo",
      payload.nomeArquivo || getFileName(payload.arquivo)
    );
  } else {
    formData.append("Mensagem", payload.mensagem || "");
  }

  return formData;
}

export function buildWhatsAppBulkFormData(
  payload: WhatsAppBulkPayload
): FormData {
  const formData = new FormData();

  payload.idsLeadCorretor365.forEach((id) => {
    formData.append("IdsLeadCorretor365", id);
  });

  formData.append("Mensagem", payload.mensagem);

  if (payload.idEmpreendimento365) {
    formData.append("IdEmpreendimento365", payload.idEmpreendimento365);
  }

  if (payload.arquivos) {
    payload.arquivos.forEach((file) => {
      formData.append("Arquivos", file);
    });
  }

  if (payload.links) {
    payload.links.forEach((link) => {
      formData.append("Links", link);
    });
  }

  if (payload.dataEnvio) {
    formData.append("DataEnvio", payload.dataEnvio);
  }

  return formData;
}
